import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from '@/store/index'
import axios, { CallBack } from "@/api/axios";
import '@/utils/iview' //view-design 全局组件
import '@/utils/element' //view-design 全局组件
import '@/style/common.less' //基本样式
import('./assets/public.css')
import 'view-design/dist/styles/iview.css';
import '@/style/custom.less' //覆盖view-design less变量
import * as custom from '@/filter' //过滤器



// import ElementUI from 'element-ui';
// Vue.use(ElementUI)


// import "swiper/css/swiper.min.css"
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Vue.component('Swiper', Swiper);
// Vue.component('SwiperSlide', SwiperSlide);

// import 'video.js/dist/video-js.css';
// import 'vue-video-player/src/custom-theme.css';
// import VideoPlayer from 'vue-video-player'
//引入 hls
// import 'videojs-contrib-hls'
// Vue.use(VideoPlayer)

import { skipCount, getDefaultCover, setMax, awaitWrap, getClassState, formatDateToX, getClassBtn, back } from "@/utils/utils";
Vue.prototype.$skipCount = skipCount
Vue.prototype.$formatDateToX = formatDateToX
Vue.prototype.$setMax = setMax;
Vue.prototype.$awaitWrap = awaitWrap;
Vue.prototype.$back = back;
Vue.prototype.$getClassBtn = getClassBtn;
Vue.prototype.$getClassState = getClassState;
Vue.prototype.$getDefaultCover = getDefaultCover;


//循环生成过滤器
Object.keys(custom).forEach((key) => {
    Vue.filter(key, custom[key])
})

//监听store中session改变，重新设置axios Authorization的值
store.subscribe((mutation) => {
    if (Object.keys(mutation.payload).includes('session')) {
        let session = mutation.payload.session
        axios.setOption('Authorization', session.accessToken ? `Bearer ${session.accessToken}` : '')
    }
})



//axios 401回调
CallBack.unauthorized = async () => {
    localStorage.removeItem("store");
    store.commit('UPDATESESSION', { session: {} })

    if (router.currentRoute.name == 'index') {
        setTimeout(() => {
            router.go(0)
        }, 1000)
    } else {
        router.replace("/index")
    }
}

//render 方法
let render = async function () {
    // eslint-disable-next-line no-useless-catch
    try {
        let session = store.state.session
        if (session.accessToken) {
            //判断session中accessToken是否存在，不存在重新登录
            axios.setOption('Authorization', `Bearer ${session.accessToken}`) //持久化插件刷新时没有触发mutation,不能监听到，手动注入axios Authorization
            return true
        } else {
            await store.commit('UPDATESESSION', { session: {} })
            return true
        }
    } catch (e) {
        throw e
    }
}
Number.prototype.toFixed = function (digits) {
    digits = digits + 1
    let str = this.toString();
    let strIndex = str.indexOf('.');
    if (strIndex === -1) return str + '.00';
    if (this && str.length < 4) {
        str = str + "0";
    }
    str = str.substring(0, strIndex + digits);
    return str;
};
render().then(() => {
    new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount('#app')
})